<template>
  <!-- <a-config-provider :getPopupContainer="getPopupContainer"> -->
  <div id="app">
    <!-- <dd-login v-if="dtalktype == 1"></dd-login>
    <zzd-login v-else-if="dtalktype == 2"></zzd-login> -->
    <router-view />
  </div>
</template>

<script>
// import dd from "dingtalk-jsapi";
// import dingtalk from '@/components/DingTalk.vue'
// import ddLogin from '@/views/dd-login.vue'
// import zzdLogin from '@/views/zzd-login.vue'
// import { removeToken } from "@/utils/token";
export default {
  name: "app",
  // mixins:[ddLogin,zzdLogin],
  // components: {ddLogin, zzdLogin},
  data() {
    return {
    };
  },
  computed: {},
  created() {
    
    // removeToken("gridName");removeToken("gridPhone");
    if(this.dtalktype == 1)
      this.$router.push({name: "dlogin", query:{jumpurl: window.location.href}})
    else if(this.dtalktype == 2)
      this.$router.push({name: "zlogin", query:{jumpurl: window.location.href}})
    // console.log('dtalktype', this.dtalktype)
    // if (dd.env.platform !== "notInDingTalk") {
    //   dd.config({
    //     agentId: "1593264935", // 必填，微应用ID
    //     corpId: "ding97c098cf44f95205ee0f45d8e4f7c288", //必填，企业ID
    //     timeStamp: new Date().getTime(), // 必填，生成签名的时间戳
    //     nonceStr: "communication", // 必填，自定义固定字符串。
    //     signature: "24124324", // 必填，签名
    //     type: 0, //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
    //     jsApiList: [
    //       "runtime.info",
    //       "biz.contact.choose",
    //       "device.notification.confirm",
    //       "device.notification.alert",
    //       "device.notification.prompt",
    //       "biz.ding.post",
    //       "biz.util.openLink",
    //       "biz.telephone.call",
    //     ], // 必填，需要使用的jsapi列表，注意：不要带dd。
    //   });

    //   dd.error(function (err) {
    //     alert("dd error: " + JSON.stringify(err));
    //   }); //该方法必须带上，用来捕获鉴权出现的异常信息，否则不方便排查出现的问题
    // }
  },
  mounted() {
  },
  methods: {},
};
</script>
<style>
.ant-tooltip-placement-bottom .ant-tooltip-arrow,
.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,
.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  top: -13px !important;
}
.ant-radio-inner {
  height: 16px !important;
  width: 16px !important;
}
form input[type="radio"],
form input[type="checkbox"] {
  height: 16px !important;
  width: 16px !important;
}
</style>

<style lang="scss">
body {
  margin: 0;
  overflow-x: auto;
  color: #323233;
  background-color: #f0f1f3;
  -webkit-font-smoothing: antialiased;
}
#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", SimSun, sans-serif;
  width: 100%;
  height: 100%;
  font-size: 14px;
}
</style>
